import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
  en: {
    nav_contact: 'Contact',
    nav_privacy_policy: 'Privacy policy',
    nav_terms_of_use: 'Terms of use',
    nav_cookie_policy: 'Cookie policy',
    venue_code: 'KUVO ID',
    venue_code_ex:
        'A KUVO ID is a unique 7-digit code per venue. You need to register your venue information to create one.',
    forgot_your_venue_code: '*Forgot your KUVO ID?',
    pioneer_dj_account: 'AlphaTheta Account e-mail',
    pioneer_dj_account_ex: `AlphaTheta Account is required to log in to the venue menu. Don't have one?`,
    pioneer_dj_account_ex_link: `Sign up now`,
    password: 'Password',
    password_ex: 'Please enter your AlphaTheta Account password.',
    forgot_your_password: '*Forgot your password?',
    button_login: 'Log in',
    keep_me_logged_in: 'Keep me logged in',
    dont_have_one: `Don't have one?`,
    create_pioneer_dj_account: 'Create an AlphaTheta Account',
    kuvo_venue_registration: 'Create a KUVO venue account',
    button_registration: 'Sign up',
  },
});

export default strings;
